import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import LifeBridge from '@tnlife/tn-bridge';
import { setDarkTheme } from '@life_uikit/uikit/helpers';
import TheTopbar from '@/components/layout/TheTopbar.vue';
import MobileTabBar from '@/components/layout/MobileTabBar.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'page-layout',
  setup(__props) {

const route = useRoute();

// Тап-бар — только на верхнеуровневом экране (список форм); в билдере,
// результатах и заполнении место дорого и случайный тап уводит из контекста.
const showTabbar = computed(() => route.name === 'forms');

// Ключ для router-view: для маршрутов формы — по имени+id, чтобы переход между
// табами одной формы (Конструктор ↔ Настройки ?tab=settings) НЕ перемонтировал
// view и не дёргал шапку. Для остальных — по полному пути.
const routeKey = computed<string>(() => {
  const id = route.params.id;
  return id ? `${String(route.name)}:${String(id)}` : route.fullPath;
});

// Топбар скрыт только на маршрутах meta.widget (публичное заполнение).
// В обоих режимах мини-аппа (iframe и WebView) топбар показываем: суперап
// прячет свою шапку после инициализации и накладывает плавающие пилюли —
// наш топбар занимает эту полосу (профиль в нём скрыт — см. TheTopbar).
const isWidget = computed(() => !!(route.meta?.widget));

onMounted(() => {
  // Восстанавливаем тему из localStorage (dev)
  const saved = localStorage.getItem('forms-theme');
  if (saved === 'dark') {
    setDarkTheme('dark');
    document.documentElement.classList.add('tn-dark-theme');
    document.body.classList.add('tn-dark-theme');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["zk-shell", { 'zk-shell--widget': isWidget.value }])
  }, [
    (!isWidget.value)
      ? (_openBlock(), _createBlock(TheTopbar, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("main", {
      class: _normalizeClass(["zk-shell__content", { 'zk-shell__content--tabbed': showTabbar.value }])
    }, [
      (_openBlock(), _createBlock(_component_router_view, { key: routeKey.value }))
    ], 2),
    (showTabbar.value)
      ? (_openBlock(), _createBlock(MobileTabBar, { key: 1 }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})